import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { fetchUserProfile } from '../../services/api';
import Sidebar from './Sidebar'; // Import the new Sidebar
import 'bootstrap/dist/css/bootstrap.min.css';

const Dashboard = () => {
    const location = useLocation();
    const [userProfile, setUserProfile] = useState(null);
    const [error, setError] = useState(null);

    const [sidebarCollapsed, setSidebarCollapsed] = useState(
        () => JSON.parse(localStorage.getItem('sidebarCollapsed')) || false
      );
    
      useEffect(() => {
        localStorage.setItem('sidebarCollapsed', JSON.stringify(sidebarCollapsed));
      }, [sidebarCollapsed]);

    const token = localStorage.getItem('authToken');

    useEffect(() => {
        const loadProfile = async () => {
            try {
                const profileData = await fetchUserProfile(token);
                setUserProfile(profileData);
            } catch (err) {
                setError(err.detail || 'Error fetching user profile');
                console.error('Error fetching user profile:', err);
            }
        };
        loadProfile();
    }, [token]);

    const getClassName = () => location.pathname === '/birthdays' ? 'body-birthdays' : '';

    return (
        <div className='dashboard-background'>
            <div className={`container-fluid ${getClassName()}`}>
                {error && <div style={{ color: 'red' }}>{error}</div>}
                <div className="d-flex">
                    {/* Sidebar */}
                    <Sidebar userProfile={userProfile}
                        isCollapsed={sidebarCollapsed}
                        setIsCollapsed={setSidebarCollapsed}
                    />

                    {/* Main Content */}
                    <main className="flex-grow-1 px-4"
                        style={{
                            minHeight: '80vh',
                            marginLeft: sidebarCollapsed ? '60px' : '220px'
                        }}>
                        <div className="text-center mb-4 d-flex align-items-center justify-content-center">
                            <img
                                src="https://res.cloudinary.com/dnbbm9vzi/image/upload/v1736174973/image-removebg-preview_1_rez4gn.png"
                                alt="Logo"
                                style={{ width: '100px', height: '100px', marginRight: '0px' }}
                            />
                            <h1 className="fw-bold d-inline mb-0">Jessster Times</h1>
                        </div>

                        {/* Welcome section for homepage */}
                        {location.pathname === '/dashboard' && (
                            <div className="row align-items-center justify-content-center" style={{ flex: 1 }}>
                                <div className="col-md-6 text-center">
                                    <h1 className="mb-3 fw-bold">Welcome to your Jessster dashboard!</h1>
                                    <h6 className="fw-bold mb-3">Liked articles hang out here until you want to revisit them.</h6>
                                    <p className="fw-bold"> Use the menu on the left to create your own posts and explore new surprises we’ve cooked up.
                                    </p>
                                    <p className="fw-bold"> Pop in often — you never know what might appear.
                                    </p>
                                </div>
                                <div className="col-md-6 text-center">
                                    <img
                                        src="https://res.cloudinary.com/dnbbm9vzi/image/upload/v1736173686/animals___costume_halloween_outfit_clothes_clothing_cat_feline_kitten_woman_people_vdpry9.png"
                                        alt="Welcome"
                                        className="img-fluid"
                                        style={{ maxWidth: '100%', height: 'auto' }}
                                    />
                                </div>
                            </div>
                        )}

                        {/* Render child routes */}
                        <Outlet context={{ userProfile }} />
                    </main>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;
